export default "__VITE_ASSET__BEtIoERR__"